import { createContext } from '@lit/context';
import { EntryComponentConfig } from '../shared/types/common.model';

export const configContext = createContext<EntryComponentConfig>(Symbol('config'));
